import { FC, useCallback } from 'react';
import Image from 'next/image';
import { Flex, SimpleGrid } from '@chakra-ui/react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import useT from '@/lib/t';

import FullPage from '@/src/components/UI/FullPage';

const RealEstateBrokerageLicense = () => {
  const t = useT();
  return (
    <FullPage text={''} title={t('share.header.license')} hasHeaderPlaceHolder>
      <Flex display={{ base: 'none', sm: 'unset' }}>
        <p className='text-2xl leading-loose font-medium text-dark-grey uppercase mb-6'>不動產經紀業許可</p>
      </Flex>

      <p className='leading-normal tracking-wide uppercase whitespace-pre-wrap mb-6'>
        {`FUNWOO 已正式加入台北市不動產仲介經紀商業同業公會，會員編號為 1100207。\n\n如下為工會會員證明文件：`}
      </p>

      <SimpleGrid spacing={{ base: 4, sm: 8 }} columns={{ base: 1, sm: 2 }} w={'100%'}>
        {filesUrl.map((res) => {
          return <LicenseItem key={res.file} {...res} />;
        })}
      </SimpleGrid>
    </FullPage>
  );
};

interface LicenseItemProps {
  name: string;
  image: string;
  file: string;
}

const LicenseItem: FC<LicenseItemProps> = ({ name, image, file }) => {
  const openFile = useCallback(() => {
    window.open(file);
  }, [file]);
  return (
    <div className={'w-full'}>
      <div onClick={openFile} className={' border border-gray300 relative cursor-pointer'}>
        <div className={'w-full'}>
          <Image layout={'responsive'} src={image} width={928} height={1328} />
        </div>
        <div className={' px-4 py-4 h-20 w-full absolute bottom-0 left-0 bg-white'}>
          <p className='leading-normal tracking-wide'>{name}</p>
        </div>
      </div>
    </div>
  );
};
const filesUrl = [
  {
    name: '01_附件一_德載國際不動產台北市地政局經營許可核准公文1091230.pdf',
    image: `${process.env.NEXT_PUBLIC_GOOGLE_CDN_URL}/mobile/largeImages/01_%E9%99%84%E4%BB%B6%E4%B8%80_%E5%BE%B7%E8%BC%89%E5%9C%8B%E9%9A%9B%E4%B8%8D%E5%8B%95%E7%94%A2%E5%8F%B0%E5%8C%97%E5%B8%82%E5%9C%B0%E6%94%BF%E5%B1%80%E7%B6%93%E7%87%9F%E8%A8%B1%E5%8F%AF%E6%A0%B8%E5%87%86%E5%85%AC%E6%96%871091230.png`,
    file: `${process.env.NEXT_PUBLIC_GOOGLE_CDN_URL}/mobile/pdfs/01.pdf`,
  },
  {
    name: '02_附件二_德載國際不動產公會會員證書.jpg',
    image: `${process.env.NEXT_PUBLIC_GOOGLE_CDN_URL}/mobile/largeImages/02_%E9%99%84%E4%BB%B6%E4%BA%8C_%E5%BE%B7%E8%BC%89%E5%9C%8B%E9%9A%9B%E4%B8%8D%E5%8B%95%E7%94%A2%E5%85%AC%E6%9C%83%E6%9C%83%E5%93%A1%E8%AD%89%E6%9B%B8_2025_01_20.png`,
    file: `${process.env.NEXT_PUBLIC_GOOGLE_CDN_URL}/mobile/largeImages/02_%E9%99%84%E4%BB%B6%E4%BA%8C_%E5%BE%B7%E8%BC%89%E5%9C%8B%E9%9A%9B%E4%B8%8D%E5%8B%95%E7%94%A2%E5%85%AC%E6%9C%83%E6%9C%83%E5%93%A1%E8%AD%89%E6%9B%B8_2025_01_20.png`,
  },
  {
    name: '03_附件三_不動產經紀人證書.pdf',
    image: `${process.env.NEXT_PUBLIC_GOOGLE_CDN_URL}/mobile/largeImages/03_%E9%99%84%E4%BB%B6%E4%B8%89_%E4%B8%8D%E5%8B%95%E7%94%A2%E7%B6%93%E7%B4%80%E4%BA%BA%E8%AD%89%E6%9B%B8_20231214.png`,
    file: `${process.env.NEXT_PUBLIC_GOOGLE_CDN_URL}/mobile/pdfs/03.pdf`,
  },
  {
    name: '04_附件四_報酬標準及收取方式.jpg',
    image: `${process.env.NEXT_PUBLIC_GOOGLE_CDN_URL}/mobile/pdfs/04_%E9%99%84%E4%BB%B6%E5%9B%9B_%E5%A0%B1%E9%85%AC%E6%A8%99%E6%BA%96%E5%8F%8A%E6%94%B6%E5%8F%96%E6%96%B9%E5%BC%8F.jpg`,
    file: `${process.env.NEXT_PUBLIC_GOOGLE_CDN_URL}/mobile/largeImages/04.jpeg`,
  },
  {
    name: '05_附件五_合法仲介經紀業識別標誌.jpg',
    image: `${process.env.NEXT_PUBLIC_GOOGLE_CDN_URL}/mobile/largeImages/05_%E9%99%84%E4%BB%B6%E4%BA%94_%E5%90%88%E6%B3%95%E4%BB%B2%E4%BB%8B%E7%B6%93%E7%B4%80%E6%A5%AD%E8%AD%98%E5%88%A5%E6%A8%99%E8%AA%8C_2025_01_20.png`,
    file: `${process.env.NEXT_PUBLIC_GOOGLE_CDN_URL}/mobile/largeImages/05_%E9%99%84%E4%BB%B6%E4%BA%94_%E5%90%88%E6%B3%95%E4%BB%B2%E4%BB%8B%E7%B6%93%E7%B4%80%E6%A5%AD%E8%AD%98%E5%88%A5%E6%A8%99%E8%AA%8C_2025_01_20.png`,
  },
  {
    name: '06_附件六_繳存保證金交易有保障.jpg',
    image: `${process.env.NEXT_PUBLIC_GOOGLE_CDN_URL}/mobile/pdfs/06_%E9%99%84%E4%BB%B6%E5%85%AD_%E7%B9%B3%E5%AD%98%E4%BF%9D%E8%AD%89%E9%87%91%E4%BA%A4%E6%98%93%E6%9C%89%E4%BF%9D%E9%9A%9C.jpg`,
    file: `${process.env.NEXT_PUBLIC_GOOGLE_CDN_URL}/mobile/largeImages/06.jpeg`,
  },
];
export default RealEstateBrokerageLicense;

export const getStaticProps = async ({ locale }: { locale: string }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
};
